import {HttpResponse} from '@angular/common/http';
import {Nachweis} from '@wba/models/nachweis';
import {UAParser} from 'ua-parser-js';
import {IosDownloadDialogComponent} from '@wba-ui-module/components/dialogs/ios-download-dialog/ios-download-dialog.component';
import {NachweisDto} from '@wba/models/dto/nachweis-dto';
import {FileEntry} from "@wba-ui-module/components/file-upload/file-entry";
import {FileUploadState} from "@wba-ui-module/components/file-upload/file-upload-state";

declare let window;

interface WindowURLInterface {
  createObjectURL: (blob: Blob) => ConstrainDOMString;
  revokeObjectURL: (data: ConstrainDOMString) => void;
}

export const generatedFileKontext = ['ANTRAG_TAG_DER_ANTRAGSTELLUNG', 'WEITERBEWILLIGUNGSANTRAG', 'ANTRAG_ANLAGE_KDU', 'ANTRAG_ANLAGE_EK'];

export class FileUtils {

  public static downloadFile(response: HttpResponse<Blob>, filename: string) {
    const url = window.URL || window.webkitURL || window.mozURL || window.msURL;
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob([response.body], {type: response.headers.get('content-type')});
    const data = url.createObjectURL(newBlob);

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator?.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, filename);
      return false
    }

    const ua = new UAParser();
    if (ua.getOS().name === 'iOS') {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        this.createDownloadPopupForIos(base64data, filename);
      };
      reader.readAsDataURL(newBlob);
      return false
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = data.toString();
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      link.remove();
      (window.URL as WindowURLInterface).revokeObjectURL(data);
    });
    return false;
  }

  public static filterGeneratedFiles(nachweise: Nachweis[]) {
    return nachweise.filter(n => generatedFileKontext.includes(n.kontext));
  }

  public static filterUploadedFiles(nachweise: Nachweis[]) {
    return nachweise.filter(n => !generatedFileKontext.includes(n.kontext));
  }

  static createDownloadPopupForIos(blob: string, filename: string) {
    const dialog = document.getElementById('IosDownloadModal');
    const anchorElement = dialog.querySelector<HTMLAnchorElement>('a');
    anchorElement.href = blob;
    anchorElement.download = filename;

    IosDownloadDialogComponent.open();
  }

  static mapSuccessfulUploads(list: FileEntry[]): NachweisDto[] {
    return list
      .filter(file => file.state == FileUploadState.SUCCESS)
      .map(file => new NachweisDto(file.id, file.dateiname));
  }

}
